/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react'
import { makeStyles, useTheme, Theme, createStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import LastPageIcon from '@material-ui/icons/LastPage'
import moment from 'moment'
import { FaBuilding, FaUser, FaGlobe, FaPhone, FaEnvelope } from 'react-icons/fa'
import { Image } from 'react-bootstrap'
import CompanyImg from '../../../assets/img/gray_logo_icon.svg'
import HotCompanyImg from '../../../assets/img/logo-filled.png'
import CircleCheckboxIcon from '../../CircleCheckboxIcon'

const useStyles1 = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexShrink: 0,
      marginLeft: theme.spacing(2.5),
    },
  }),
)
type ColumnID =
  | 'Select'
  | 'Name'
  | 'Phone'
  | 'company'
  | 'status'
  | 'rank'
  | 'dateAdded'
  | 'leadUpdateDate'

interface Column {
  id: ColumnID
  label: string
  minWidth?: number
  align?: 'left'
  format?: (value: number) => string
}

const columns: Column[] = [
  { id: 'Select', label: 'SELECT', minWidth: 70, align: 'left' },
  { id: 'Name', label: 'NAME + TITLE', minWidth: 70, align: 'left' },
  { id: 'Phone', label: 'PHONE + EMAIL', minWidth: 70, align: 'left' },
  { id: 'company', label: 'COMPANY', minWidth: 120, align: 'left' },
  { id: 'status', label: 'STATUS', minWidth: 120, align: 'left' },
  { id: 'rank', label: 'RANK', minWidth: 70, align: 'left' },
  { id: 'dateAdded', label: 'DATE ADDED', minWidth: 70, align: 'left' },
  { id: 'leadUpdateDate', label: 'DATE UPDATED', minWidth: 70, align: 'left' },
]
interface TablePaginationActionsProps {
  count: number
  page: number
  rowsPerPage: number
  onPageChange: (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => void
}

function capitalizeFirstLetter(string) {
  return string[0].toUpperCase() + string.slice(1).toLowerCase()
}

function titleCase(string) {
  return string
    .split(' ')
    .map(x => capitalizeFirstLetter(x))
    .join(' ')
}

export const TablePaginationActions = (props: TablePaginationActionsProps): JSX.Element => {
  const classes = useStyles1()
  const theme = useTheme()
  const { count, page, rowsPerPage, onPageChange } = props

  const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    onPageChange(event, 0)
  }

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    onPageChange(event, page - 1)
  }

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    onPageChange(event, page + 1)
  }

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
  }

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  )
}

const useStyles2 = makeStyles({
  table: {
    minWidth: 500,
  },
  headCell: {
    background: '#59595B',
    color: '#fff',
    padding: '9px 10px',
    lineHeight: '17px',
    borderRight: '1px solid white',
    fontSize: 10,
    '& .icon-container': {
      marginRight: '10px !important',
    },
  },
  bodyCell: {
    padding: '16px 16px 16px 0',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  headSortCell: {
    flexDirection: 'row-reverse',
    color: 'white !important',
    '& svg': {
      color: 'white !important',
    },
  },
})

const ContactTable = (props: any) => {
  const {
    search,
    currentUser,
    setCurrentUser,
    setTypeProp,
    orderBy,
    setOrderBy,
    order,
    setOrder,
    rowsPerPage,
    setRowsPerPage,
    page,
    setPage,
    setIsSelectAll,
    SidebarExpanded,
    setSidebarExpanded,
    selectedItems,
    setselectedItems,
  } = props
  let { data } = props
  data = data.filter(item => {
    return item && item.firstName !== null
  })
  const classes = useStyles2()
  const emptyRows = 5 - data.length > 0 ? 5 - data.length : 0
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ): void => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const onCheck = (id): void => {
    const checkedItems = { ...selectedItems }
    if (checkedItems[id]) {
      delete checkedItems[id]
    } else {
      checkedItems[id] = true
    }
    setselectedItems(checkedItems)
  }

  const onChangeContact = (id, e): void => {
    e.stopPropagation()
    const currentId = data.findIndex(item => item.id === id)
    if (currentUser?.id === data[currentId]?.id && !SidebarExpanded) {
      setSidebarExpanded(true)
    }
    setCurrentUser(data[currentId])
    setTypeProp('user')
  }

  const onChangeCompanyContact = (id, e): void => {
    e.stopPropagation()
    const currentId = data.findIndex(item => item.id === id)
    setCurrentUser(data[currentId])
    setTypeProp('company')
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'

    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const createSortHandler = property => event => {
    handleRequestSort(event, property)
  }
  useEffect(() => {
    setIsSelectAll(false)
    if (!currentUser?.email) {
      setCurrentUser(data[0])
    }
  }, [])

  useEffect(() => {
    setPage(0)
  }, [data.length])
  return (
    <TableContainer component={Paper}>
      <Table stickyHeader className={classes.table} aria-label="custom pagination table">
        <TableHead>
          <TableRow>
            {columns.map((column, index) => (
              <TableCell
                key={column.id}
                align={column.align}
                style={{ minWidth: column.minWidth }}
                className={classes.headCell}
                sortDirection={orderBy === column.id ? order : false}
              >
                {index === 0 ? (
                  <div className="table-cell">
                    <div className="table-item">{column.label}</div>
                  </div>
                ) : index === 1 ? (
                  <>
                    <TableSortLabel
                      active={orderBy === 'name'}
                      direction={orderBy === 'name' ? order : 'asc'}
                      className={classes.headSortCell}
                      onClick={createSortHandler('name')}
                    >
                      {orderBy === 'name' ? (
                        <span className={classes.visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                      ) : null}
                      NAME
                    </TableSortLabel>
                    <TableSortLabel
                      active={orderBy === 'leadTitle'}
                      direction={orderBy === 'leadTitle' ? order : 'asc'}
                      className={classes.headSortCell}
                      onClick={createSortHandler('leadTitle')}
                    >
                      {orderBy === 'leadTitle' ? (
                        <span className={classes.visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                      ) : null}
                      TITLE
                    </TableSortLabel>
                  </>
                ) : index === 2 ? (
                  <>
                    <TableSortLabel
                      active={orderBy === 'phoneNumber'}
                      direction={orderBy === 'phoneNumber' ? order : 'asc'}
                      className={classes.headSortCell}
                      onClick={createSortHandler('phoneNumber')}
                    >
                      {orderBy === 'phoneNumber' ? (
                        <span className={classes.visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                      ) : null}
                      PHONE
                    </TableSortLabel>
                    <TableSortLabel
                      active={orderBy === 'email'}
                      direction={orderBy === 'email' ? order : 'asc'}
                      className={classes.headSortCell}
                      onClick={createSortHandler('email')}
                    >
                      {orderBy === 'email' ? (
                        <span className={classes.visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                      ) : null}
                      EMAIL
                    </TableSortLabel>
                  </>
                ) : (
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={orderBy === column.id ? order : 'asc'}
                    onClick={createSortHandler(column.id)}
                    className={classes.headSortCell}
                  >
                    {orderBy === column.id ? (
                      <span className={classes.visuallyHidden}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </span>
                    ) : null}
                    {column.label}
                  </TableSortLabel>
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody className="user">
          {data.map((row, index) => {
            const next: any[] = []
            if (!row) {
              return null
            }
            if (row.status === 'Active' && row.sendDates.length > 0) {
              row.sendDates.forEach((date: any) => {
                if (new Date().getTime() - new Date(date[1]).getTime() < 0) {
                  next.push(date)
                }
              })
            }
            return (
              <TableRow
                hover
                selected={currentUser?.id === row?.id}
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                onClick={(e): void => onChangeContact(row.id, e)}
              >
                {/* one of the reason of showing columns is duplicte keys so added index as a key to row */}
                <TableCell
                  component="th"
                  scope="row"
                  padding="checkbox"
                  className="check_box"
                  onClick={(): void => onCheck(row.id)}
                >
                  <div className="select-container">
                    <CircleCheckboxIcon state={!!selectedItems[row.id]} />
                    {row.addedBy === 'User' ? (
                      <div className={`avatar-icon ${row.isHot ? 'hot' : ''}`}>
                        <FaUser />
                      </div>
                    ) : (
                      <>
                        {!row.isHot && (
                          <Image
                            src={CompanyImg}
                            alt="Placeholder"
                            className="avatar"
                            roundedCircle
                          />
                        )}
                        {row.isHot && (
                          <Image
                            src={HotCompanyImg}
                            alt="Placeholder"
                            className="avatar"
                            roundedCircle
                          />
                        )}
                      </>
                    )}
                  </div>
                </TableCell>
                <TableCell style={{ width: 160 }} align="center" className={classes.bodyCell}>
                  <div className="user-column">
                    <div className="item user_name">
                      <p className="name">{`${row.firstName} ${row.lastName}`}</p>
                    </div>
                    <div className="item">
                      <p>{row.title ? row.title : row.leadTitle}</p>
                    </div>
                  </div>
                </TableCell>
                <TableCell style={{ width: 160 }} align="left" className={classes.bodyCell}>
                  <div className="user-column">
                    <div className="item">
                      <FaPhone />
                      {row.phoneNumber && <p>{row.phoneNumber}</p>}
                    </div>
                    {row.email && (
                      <div className="item">
                        <FaEnvelope />
                        <a href={`mailto:${row.email}`}>{row.email}</a>
                      </div>
                    )}
                  </div>
                </TableCell>
                <TableCell style={{ width: 160 }} align="left" className={classes.bodyCell}>
                  <div className="user-column">
                    {row.company && (
                      <div
                        className="item"
                        onClick={(e): void => onChangeCompanyContact(row.id, e)}
                        tabIndex={-42}
                        role="presentation"
                        onKeyDown={(): void => {}}
                      >
                        <FaBuilding />
                        <p className="company_name">{row.company}</p>
                      </div>
                    )}
                    <div className="item">
                      <FaGlobe />
                      <a
                        target="_blank"
                        href={`https://${row.email?.substring(row.email.lastIndexOf('@') + 1)}`}
                        rel="noopener noreferrer"
                      >
                        {row.email?.substring(row.email.lastIndexOf('@') + 1)}
                      </a>
                    </div>
                  </div>
                </TableCell>
                <TableCell style={{ width: 160 }} align="left" className={classes.bodyCell}>
                  <div className="user-column">
                    <p>{titleCase(row.status)}</p>
                    {(row.status.toLowerCase() === 'email scheduled' ||
                      row.status.toLowerCase() === 'active') &&
                      row.sendDates &&
                      row.sendDates.length > 0 && (
                        <p>{moment(row?.sendDates[0][1]).format('MM.DD.YYYY')}</p>
                      )}
                    {row.status.toLowerCase() === 'active' && next.length !== 0 && (
                      <p>{moment(next[0][1]).format('MM.DD.YYYY')}</p>
                    )}
                    <p>{row?.missionName}</p>
                  </div>
                </TableCell>
                <TableCell style={{ width: 160 }} align="left" className={classes.bodyCell}>
                  <TableCell style={{ width: 160 }} align="left" className={classes.bodyCell}>
                    <div className="user-column">
                      <p>{row.rank}</p>
                    </div>
                  </TableCell>
                </TableCell>
                <TableCell style={{ width: 160 }} align="left" className={classes.bodyCell}>
                  <TableCell style={{ width: 160 }} align="left" className={classes.bodyCell}>
                    <div className="user-column">
                      <p>{row.dateAdded ? new Date(row.dateAdded).toLocaleDateString() : ''}</p>
                    </div>
                  </TableCell>
                </TableCell>
                <TableCell style={{ width: 160 }} align="left" className={classes.bodyCell}>
                  <TableCell style={{ width: 160 }} align="left" className={classes.bodyCell}>
                    <div className="user-column">
                      <p>
                        {row.leadUpdateDate
                          ? new Date(row.leadUpdateDate).toLocaleDateString()
                          : row.dateAdded // Added Date Added if LeadUpdate Date not found
                          ? new Date(row.dateAdded).toLocaleDateString()
                          : ''}
                      </p>
                    </div>
                  </TableCell>
                </TableCell>
              </TableRow>
            )
          })}
          {emptyRows > 0 && (
            <TableRow style={{ height: `${10 * (emptyRows * 0.95)}vh` }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 75, 100]}
              count={search?.filteredProspects?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              onPageChange={handleChangePage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
}

export default ContactTable
